module.exports = __webpack_public_path__ + "static/media/n-53-shot-02.3c3ffe32.webp";